import { Share2, MessageCircle, Twitter, Mail, Link2, Smartphone } from 'lucide-react';
import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
  DropdownMenuSeparator,
} from '@/components/ui/dropdown-menu';
import { toast } from 'sonner';
import { SHARE } from '@/constants/testIds';

const DEFAULT_TEXT =
  "I just tried Wellth — a caring health coach that gives you actionable food, supplement & workout guidance. Health is the greatest wealth. ";

const ShareMenu = ({ url, text = DEFAULT_TEXT, className = '', label = 'Share', testId = SHARE.menuButton }) => {
  const shareUrl = url || (typeof window !== 'undefined' ? window.location.origin : '');
  const canNativeShare = typeof navigator !== 'undefined' && !!navigator.share;

  const nativeShare = async () => {
    try {
      await navigator.share({ title: 'Wellth — Health is the greatest wealth', text, url: shareUrl });
    } catch (e) {
      // user cancelled
    }
  };

  const copyLink = async () => {
    try {
      await navigator.clipboard.writeText(shareUrl);
      toast.success('Link copied to clipboard');
    } catch (e) {
      toast.error('Could not copy — please copy manually');
    }
  };

  const enc = encodeURIComponent;
  const whatsappHref = `https://wa.me/?text=${enc(text + ' ' + shareUrl)}`;
  const twitterHref = `https://twitter.com/intent/tweet?text=${enc(text)}&url=${enc(shareUrl)}`;
  const emailHref = `mailto:?subject=${enc('Wellth — health is the greatest wealth')}&body=${enc(text + '\n\n' + shareUrl)}`;

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="outline"
          className={`rounded-full border-[#E5E1D8] bg-white hover:bg-[#F2EFE9] text-[#4A7C59] gap-2 px-5 ${className}`}
          data-testid={testId}
        >
          <Share2 className="w-4 h-4" strokeWidth={1.5} />
          {label}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-56 rounded-xl border-[#E5E1D8] bg-white">
        {canNativeShare && (
          <>
            <DropdownMenuItem onClick={nativeShare} data-testid={SHARE.native} className="gap-2 cursor-pointer">
              <Smartphone className="w-4 h-4" strokeWidth={1.5} /> Device share…
            </DropdownMenuItem>
            <DropdownMenuSeparator />
          </>
        )}
        <DropdownMenuItem asChild data-testid={SHARE.whatsapp}>
          <a href={whatsappHref} target="_blank" rel="noreferrer" className="gap-2 flex items-center cursor-pointer">
            <MessageCircle className="w-4 h-4" strokeWidth={1.5} /> WhatsApp
          </a>
        </DropdownMenuItem>
        <DropdownMenuItem asChild data-testid={SHARE.twitter}>
          <a href={twitterHref} target="_blank" rel="noreferrer" className="gap-2 flex items-center cursor-pointer">
            <Twitter className="w-4 h-4" strokeWidth={1.5} /> X / Twitter
          </a>
        </DropdownMenuItem>
        <DropdownMenuItem asChild data-testid={SHARE.email}>
          <a href={emailHref} className="gap-2 flex items-center cursor-pointer">
            <Mail className="w-4 h-4" strokeWidth={1.5} /> Email
          </a>
        </DropdownMenuItem>
        <DropdownMenuSeparator />
        <DropdownMenuItem onClick={copyLink} data-testid={SHARE.copyLink} className="gap-2 cursor-pointer">
          <Link2 className="w-4 h-4" strokeWidth={1.5} /> Copy link
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default ShareMenu;
